import React, {useState} from 'react'
import PropTypes from 'prop-types'
import Portal from "@Features/portals/components/Portal";
import CompanyReviewSnippet from "@Pages/companyProfile/components/CompanyReviewSnippet";
import CompanyReviewType from "@Pages/companyProfile/types/CompanyReview.type";

export const COMPANY_REVIEW_PORTAL_ID = 'company-review-portal'

interface CompanyReviewPortalProps {
    companyReviews: CompanyReviewType[]
}

function CompanyReviewPortal({companyReviews}: CompanyReviewPortalProps) {
    const [readMoreExpanded, setReadMoreExpanded] = useState(false)

    return (
        <Portal id={COMPANY_REVIEW_PORTAL_ID}>
            <div className="gb--row gb--cards">
                {companyReviews.map((companyReview) => (
                    <CompanyReviewSnippet
                        key={companyReview?.dateTime}
                        companyReview={companyReview}
                        readMoreExpanded={readMoreExpanded}
                        setReadMoreExpanded={setReadMoreExpanded}
                    />
                ))}
            </div>
        </Portal>
    )
}

CompanyReviewPortal.propTypes = {
    companyReviews: PropTypes.array.isRequired,
}

export default CompanyReviewPortal